import * as angular from 'angular';

import { ComponentDefinition, DigitalSet, ImportResult } from '../../../../models';
import { IDigitalSetService, ILoggerService } from '../../../../services';
import { guidEmpty } from '../../../../common/constants';

class DigitalStatesUploadModalController implements angular.IComponentController, angular.IOnDestroy {
    fileList: FileList = {} as FileList;
    importResult: ImportResult;
    isFileUploaded: boolean;
    isLoading: boolean;

    readonly refresh: ({ force: boolean }) => void;
    readonly selectedSet: DigitalSet;

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        'digitalSetService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _digitalSetService: IDigitalSetService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this._garbages.push(this._$scope.$watch(() => this.fileList, (oldItem, newItem) => {
            if (oldItem && newItem) {
                this.reset(true);
            }
        }));
    }

    $onDestroy(): void {
        this._garbages.forEach(g => g());
    }

    upload(fileList: FileList, set: DigitalSet, $event) {
        if (fileList && fileList.length > 0) {
            const digitalSetGuid = set ? set.guid : guidEmpty;
            const file = fileList[0];
            this._digitalSetService
                .upload(file, digitalSetGuid)
                .then(data => {
                    this.importResult = {
                        result: data.result,
                        createdCount: data.created.length,
                        updatedCount: data.updated.length,
                        failedCount: data.notUpdated.length
                    };
                    this.isFileUploaded = true;
                })
                .catch(reason => {
                    this._loggerService.logError(reason.data.Message);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }

    reset(isNewFileSelected: boolean = false): void {
        this.importResult = undefined;
        this.isFileUploaded = false;
        if (!isNewFileSelected) {
            this.fileList = undefined;
            if (this.refresh) {
                this.refresh({ force: true });
            }
        }
    }
}

export const wtDigitalStatesUploadModal: ComponentDefinition = {
    componentId: 'wtDigitalStatesUploadModal',
    controller: DigitalStatesUploadModalController,
    template: require('./digitalStatesUploadModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        refresh: '&',
        selectedSet: '<'
    }
};